import React from 'react';
import { DataTable } from '../../../../../common';
import { Grid, IconButton, Tooltip } from '@mui/material';
import GetAppIcon from '@mui/icons-material/GetApp';

function AnalysisResultsDialog(props) {
    const { fields, filteredData, order, sort, getResultsPending, refreshLineItems, analysisResultsData, clientName, claimNumber,
        actions: { setOrder, setSort, downloadAnalysisResults } } = props;
        
    function handleExportAnalysisResults() {
        if (analysisResultsData && analysisResultsData.length > 0) {
            const analysisIds = analysisResultsData[0].AnalysisIds;
            downloadAnalysisResults(analysisIds, downloadCallback);
        }
    }

    function downloadCallback(blob) {
        const fileNameParts = [clientName];

        if (claimNumber) {
            fileNameParts.push(claimNumber);
        }
        fileNameParts.push('ModelAnalysisResults_Report.csv');

        const fileName = fileNameParts.join('_');

        let url = window.URL.createObjectURL(blob);
        let a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(url);
    }

    function tableLevelActions() {
        return (
            <>
                <Grid item>
                    <Tooltip title="Export">
                        <IconButton
                            aria-label="export"
                            size='small'
                            onClick={handleExportAnalysisResults}
                        >
                            <GetAppIcon />
                        </IconButton>
                    </Tooltip>
                </Grid>
            </>
        );
    }

    return (
        <DataTable
            fields={fields}
            data={filteredData}
            order={order}
            onOrder={setOrder}
            sort={sort}
            onSort={setSort}
            loading={getResultsPending}
            displayTotal={true}
            handleRefresh={refreshLineItems}
            tableLevelActions={tableLevelActions}
        />
    )
}

export default AnalysisResultsDialog;
